class WishlistQuickAdd extends HTMLElement {
    constructor() {
      super();
      
      this.addEventListener('click', () => this.onClick());

    }
  
    onClick() {
        let variantId = this.dataset.id;

        fetch('/cart.js', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            }
        }).then(response => response.json()).then(cart => {
            let existingItem = cart.items.find(item => item.variant_id == variantId);

            if (existingItem) {
                let updatedQuantity = existingItem.quantity + 1;
    
                fetch('/cart/change.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                    },
                    body: JSON.stringify({ id: existingItem.key, quantity: updatedQuantity })
                }).then(response => response.json()).then(json => {
                    WishlistQuickAdd.getCart();
                    WishlistQuickAdd.open();
                }).catch(error => console.error(error));
            } else {
                fetch('/cart/add.js', {
                    body: JSON.stringify({id: variantId, quantity: 1}),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With':'xmlhttprequest'
                    },
                    method: 'POST'
                }).then(function(response) {
                    return response.json();
                }).then(function(json) {
                    WishlistQuickAdd.getCart();
                    WishlistQuickAdd.open();
                }).catch(function(err) {
                    console.error(err)
                });
            }
        }).catch(err => console.error(err));
    }

    static open() {
        document.querySelector('.cart-background').classList.add('active');
        document.getElementById('cart-notification').classList.add('animate', 'active');
        document.querySelector('.cart-notification-wrapper').classList.add('active');
        document.querySelector('body').classList.add('cart--open');
    
        document.getElementById('cart-notification').addEventListener('transitionend', () => {
            document.getElementById('cart-notification').focus();
            trapFocus(document.getElementById('cart-notification'));
        }, 
        { once: true });
    }

    static getCart() {
        fetch(window.Shopify.routes.root + `cart.js?${document.querySelector('cart-notification').getSectionsToRender().map((section) => section.id)}`)
        .then(response => response.json())
        .then(data => { 
            return document.querySelector('cart-notification').buildCart(data) 
        });
    }
}
  
customElements.define('wishlist-quick-add', WishlistQuickAdd);
